// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BiS7","toggleWrap":"styles_toggleWrap__3_65E","content":"styles_content__bwf3_","selectAreaCode":"styles_selectAreaCode__ddKVu"};